<template>
  <div v-if="userProfile.name" id="Navigation">
    <nav class="level is-mobile navbar is-fixed-top has-page-background">
      <div class="level-left">
        <div class="level-item">
          <div v-if="!isNavOverlay">
            <b-tooltip v-if="this.$route.path !== '/posts'" :label="$t('navigation.back')" position="is-bottom" type="is-black">
              <router-link to="/posts" class="has-margin-x-md button is-brand is-circle">
                <i class="ri-arrow-left-line has-text-info"></i>
              </router-link>
            </b-tooltip>
            <b-tooltip v-else :label="$t('navigation.menu')" position="is-bottom" type="is-black">
              <a @click="toggleNav" class="has-margin-x-md button is-brand is-circle">
                <i class="ri-dashboard-fill has-text-info"></i>
              </a>
            </b-tooltip>
          </div>
          <div v-else>
            <b-tooltip :label="$t('navigation.close')" position="is-bottom" type="is-black">
              <a @click="toggleNav" class="has-margin-x-md button is-brand is-circle">
                <i class="ri-close-line has-text-info"></i>
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div v-if="!isNavOverlay">
          <b-tooltip v-if="this.$route.path !== '/posts'" :label="$t('navigation.view-posts')" position="is-bottom" type="is-black">
            <router-link to="/posts">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-right: 20px;">
                <i class="ri-roadster-line ri-lg has-text-success"></i><!--&nbsp;Discover-->
              </div>
            </router-link>
          </b-tooltip>
          <b-tooltip v-else :label="$t('navigation.current-page')" position="is-bottom" type="is-black">
            <router-link to="/posts">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-right: 20px;">
                <i class="ri-roadster-line ri-lg has-text-success"></i><!--&nbsp;Discover-->
              </div>
            </router-link>
          </b-tooltip>
        </div>
        <div v-else>
          <b-tooltip v-if="this.$route.path !== '/posts'" :label="$t('navigation.view-posts')" position="is-bottom" type="is-black">
            <router-link to="/posts">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-right: 20px;">
                <i class="ri-roadster-line ri-lg has-text-success"></i><!--&nbsp;Discover-->
              </div>
            </router-link>
          </b-tooltip>
          <b-tooltip v-else :label="$t('navigation.view-posts')" position="is-bottom" type="is-black">
            <a @click="toggleNav">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-right: 20px;">
                <i class="ri-roadster-line ri-lg has-text-success"></i><!--&nbsp;Discover-->
              </div>
            </a>
          </b-tooltip>
        </div>

        <b-tooltip :label="$t('navigation.my-dashboard')" position="is-bottom" type="is-black">
          <a @click="toggleNav" style="margin-top:10px">
            <div class="button is-primary is-outlined">
              <div v-if="!isNavOverlay">
                <i class="ri-menu-line"></i> 
              </div>
              <div v-else>
                <i class="ri-close-line has-text-danger"></i> 
              </div>
            </div>
          </a>
        </b-tooltip>

        <div v-if="!isNavOverlay">
          <b-tooltip v-if="this.$route.path !== '/activity'" :label="$t('navigation.my-activity')" position="is-bottom" type="is-black">
            <router-link to="/activity">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-left: 20px;">
                <i class="ri-broadcast-line ri-lg has-text-success"></i><!--&nbsp;{{ userProfile.name }}-->
              </div>
            </router-link>
          </b-tooltip>
          <b-tooltip v-else :label="$t('navigation.current-page')" position="is-bottom" type="is-black">
            <router-link to="/activity">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-left: 20px;">
                <i class="ri-broadcast-line ri-lg has-text-success"></i><!--&nbsp;{{ userProfile.name }}-->
              </div>
            </router-link>
          </b-tooltip>
        </div>
        <div v-else>
          <b-tooltip v-if="this.$route.path !== '/activity'" :label="$t('navigation.my-activity')" position="is-bottom" type="is-black">
            <router-link to="/activity">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-left: 20px;">
                <i class="ri-broadcast-line ri-lg has-text-success"></i><!--&nbsp;{{ userProfile.name }}-->
              </div>
            </router-link>
          </b-tooltip>
          <b-tooltip v-else :label="$t('navigation.current-page')" position="is-bottom" type="is-black">
            <a @click="toggleNav">
              <div class="button is-brand is-small has-padding-10" style="margin-top: 6px; margin-left: 20px;">
                <i class="ri-home-line ri-lg has-text-success"></i><!--&nbsp;{{ userProfile.name }}-->
              </div>
            </a>
          </b-tooltip>
        </div>
      </div>
      
      <div class="level-right">
        <div class="level-item has-text-right">
          <div v-if="!isNavOverlay">
            <b-tooltip :label="$t('navigation.post')" position="is-bottom" type="is-black">
              <router-link to="/post" class="has-margin-x-md button is-primary-grad-circle is-circle has-shadow-dark">
                <i class="ri-add-line"></i>
              </router-link>
            </b-tooltip>
          </div>
          <div v-else>
            <b-tooltip v-if="this.$route.path !== '/post'" :label="$t('navigation.post')" position="is-bottom" type="is-black">
              <router-link to="/post" class="has-margin-x-md button is-primary-grad-circle is-circle has-shadow-dark">
                <i class="ri-add-line"></i>
              </router-link>
            </b-tooltip>
            <b-tooltip v-else :label="$t('navigation.post')" position="is-bottom" type="is-black">
              <a @click="toggleNav" class="has-margin-x-md button is-primary-grad-circle is-circle has-shadow-dark">
                <i class="ri-add-line"></i>
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </nav>

    <!-- The overlay -->
    <div id="dashboardNav" class="overlay">
      <!-- Overlay content -->
      <div class="overlay-content">
        <Dashboard ref="dashboardnav"></Dashboard>
      </div>
    </div>
  </div>
  <div v-else>
    <nav class="level is-mobile navbar is-fixed-top has-page-background">
      <div class="level-left">
        <div class="level-item">
          <b-tooltip v-if="this.$route.path !== '/posts'" :label="$t('navigation.back')" position="is-bottom" type="is-black">
            <router-link to="/posts" class="has-margin-x-md button is-black is-circle has-shadow-dark">
              <i class="ri-arrow-left-line has-text-info"></i> 
            </router-link>
          </b-tooltip>
          <b-tooltip v-else :label="$t('navigation.about')" position="is-bottom" type="is-black">
            <router-link to="/about" class="has-margin-x-md">
              <img src="@/assets/logo.png" alt="Eco Whips" width="140px;">
            </router-link >
          </b-tooltip>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-tooltip :label="$t('navigation.post')" position="is-bottom" type="is-black">
            <router-link to="/login" class="has-margin-x-md button is-small is-primary-grad is-rounded">
              <i class="ri-user-line"></i> &nbsp;Sign In
            </router-link>
          </b-tooltip>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Dashboard from '@/components/Dashboard'

export default {
  data() {
    return {
      isNavOverlay: false,
    };
  },

  components: {
    Dashboard
  },

  computed: {
    ...mapState(["userProfile"]),
  },

  methods: {
    toggleNav: function() {
      if (this.isNavOverlay != true){
        document.getElementById("dashboardNav").style.height = "100%";
        this.isNavOverlay = true;
      } else {
        console.log("toggleNav false");
        document.getElementById("dashboardNav").style.height = "0%";
        this.isNavOverlay = false;
      }
    },
  },
};
</script>